export default __webpack_public_path__ + "static/media/restaurant.1525da4d.mp4";